import { createSelector } from 'reselect'
import {
  MY_UPLOADS,
  SHARED_WITH_ME,
  documentTypesByUmbrella, 
  parseParentFolderName 
} from 'utils/Client/documents'


const sortByCreatedAt = (a,b) => {
  const aDocument = a.attributes.createdAt
  const bDocument = b.attributes.createdAt
  if (new Date(aDocument) < new Date(bDocument)) {
    return 1
  } else {
    return -1
  }
}
const groupDocumentsByParentFolderName = (documents, documentTypes) => (
  documents.reduce((docsGroup, doc) => {
    let { parentFolderName } = doc.attributes
    parentFolderName = parseParentFolderName(parentFolderName)
    let docsGroupUpdated = { ...docsGroup }

    if (documentTypes.includes(parentFolderName)) {
      const parentFolderInDocsGroup = docsGroupUpdated[parentFolderName]

      docsGroupUpdated = {
        ...docsGroupUpdated,
        [parentFolderName]: parentFolderInDocsGroup ? [...parentFolderInDocsGroup, doc] : [doc]
      }
    }
    return docsGroupUpdated
  }, {})
)
const orderGroupOfDocuments = docsGroup => (
  Object.keys(docsGroup).reduce((docsGroupAccumulator, parentFolderName) => (
    {
      ...docsGroupAccumulator,
      [parentFolderName]: docsGroup[parentFolderName].sort(sortByCreatedAt)
    }
  ), {})
)
const getDocumentByType = (state, documentTypes) => {
  const {
    documents
  } = state
  const filteredDocs = groupDocumentsByParentFolderName(documents, documentTypes)
  return orderGroupOfDocuments(filteredDocs)
}

const getDocumentsState = state => state.documents

export const getMyUploadedDocs = createSelector(
  getDocumentsState,
  documentsState => (
    getDocumentByType(documentsState, documentTypesByUmbrella(MY_UPLOADS))
  )
)

export const getSharedWithMeDocs = createSelector(
  getDocumentsState,
  documentsState =>  (
    getDocumentByType(documentsState, documentTypesByUmbrella(SHARED_WITH_ME))
  )
)

export default {
  getMyUploadedDocs,
  getSharedWithMeDocs
}



// WEBPACK FOOTER //
// ./src/selectors/onlineExperience/documents.js